import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { bomItemSelector } from './bomItemSelector'

export function headerRowsCounter(
  state: RootAppState,
  bomItemId: string
): { filtered: number; total: number } {
  const bomItem = bomItemSelector(
    state,
    bomItemId,
    state.project.currentView === ProjectViews.AssemblyHierarchy
  )

  switch (bomItem?.type) {
    case 'Row':
      break
    default:
      return {
        filtered: bomItem.filteredPartTypeIds.length,
        total: bomItem.partTypeIds.length,
      }
  }

  return { filtered: 0, total: 0 }
}
